import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface MyCartEstimateLineItemRequest {
  productId: number;
  quantity: number;
}

export interface MyCartSaveEstimateRequest {
  organizationId: number;
  estimateId?: number;
  bookingId?: number;
  items: MyCartEstimateLineItemRequest[];
}

export interface MyCartCheckoutRequest {
  organizationId: number;
  estimateId: number;
  bookingId: number;
}

export interface MyCartEstimateLine {
  productId: number;
  name: string;
  sku: string;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
}

export interface MyCartEstimate {
  estimateId: number;
  invoiceNumber: string;
  organizationId: number;
  bookingId?: number;
  pickupDate: string;
  pickupName: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  type: string;
  status: string;
  subtotal: number;
  discount: number;
  tax: number;
  shipping: number;
  amountDue: number;
  amountPaid: number;
  items: MyCartEstimateLine[];
}

@Injectable({ providedIn: 'root' })
export class MyCartService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/my-cart';

  getEstimate(estimateId: number, organizationId: number): Observable<MyCartEstimate> {
    return this.http.get<MyCartEstimate>(`${this.apiUrl}/estimate/${estimateId}?organizationId=${organizationId}`);
  }

  saveEstimate(request: MyCartSaveEstimateRequest): Observable<MyCartEstimate> {
    return this.http.post<MyCartEstimate>(`${this.apiUrl}/save-estimate`, request);
  }

  saveQuote(request: MyCartCheckoutRequest): Observable<MyCartEstimate> {
    return this.http.post<MyCartEstimate>(`${this.apiUrl}/save-quote`, request);
  }

  changeQuote(request: MyCartCheckoutRequest): Observable<MyCartEstimate> {
    return this.http.post<MyCartEstimate>(`${this.apiUrl}/change-quote`, request);
  }

  createOrder(request: MyCartCheckoutRequest): Observable<MyCartEstimate> {
    return this.http.post<MyCartEstimate>(`${this.apiUrl}/order`, request);
  }

  checkout(request: MyCartCheckoutRequest): Observable<MyCartEstimate> {
    return this.http.post<MyCartEstimate>(`${this.apiUrl}/checkout`, request);
  }
}
